<template>
  <div>
    <section class="container">
      <ul v-if="details != ''">
        <li class="disBlock">
          <h3>{{ details.name }}</h3>
        </li>
        <li class="disBlock">
          <label>手机号：</label>
          <p>{{ details.phone }}</p>
        </li>
        <li class="disBlock">
          <label>身份证号：</label>
          <p>{{ details.id_card }}</p>
        </li>
        <li class="disBlock">
          <label>月份：</label>
          <p>{{ details.month_date.substring(0, 7) }}</p>
        </li>
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li
          v-show="details.float_data_config != ''"
          v-for="(item, k) in details.float_data_config"
          :key="k"
        >
          <label>{{ item.name + "：" }}</label>
          <p>{{ item.value }}</p>
        </li>
        <li>
          <label>当月合计收入：</label>
          <p>{{ details.amount }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.details = this.detailsVal;
    }
    // console.log(this.detailsVal);
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.details = this.detailsVal;
      // console.log(this.detailsVal);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      margin-bottom: 10px;
      h3 {
        font-size: 20px;
        line-height: 30px;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
    .disBlock {
      display: block;
    }
  }
}
</style>
